export enum BookMarkType {
  ETSBookmark,
  LegacyBookmark,
  LegacyGen0Bookmark
}
